export default __webpack_public_path__ + "static/media/trampapo_02_24.00e97dc9.jpg";